export default "__VITE_ASSET__BnmfmAps__"